// Verifications a job or a search may name although the Wallet does not offer them yet. Until a
// Wallet category is built, nobody can hold a verified credential in it, so a job must not ask an
// applicant for it and a search must not filter or rank by it.
//
// Jobs published while these could still be required keep them in their stored data. Every place
// that reads a job's stored requirements reads them through `offeredJobRequirements`, so those
// jobs stop asking without their data being rewritten, and start asking again once the category
// is built and removed from the Wallet's unbuilt list.
//
// Written as plain CommonJS so the API server, which runs its files under plain node, can require
// this same file the browser bundle imports.

const { UNBUILT_CATEGORIES } = require('./walletCatalog');

// The Wallet category each job requirement choice stands for.
const JOB_REQUIREMENT_CATEGORIES = {
  'Work Experience': 'experience',
  Education: 'education',
};

// The Wallet category each verification key used by search stands for.
const SEARCH_KEY_CATEGORIES = {
  experience: 'experience',
  education: 'education',
};

const isUnbuilt = category => !!category && UNBUILT_CATEGORIES.includes(category);

const UNBUILT_JOB_REQUIREMENTS = Object.keys(JOB_REQUIREMENT_CATEGORIES).filter(requirement =>
  isUnbuilt(JOB_REQUIREMENT_CATEGORIES[requirement])
);

const isOfferedJobRequirement = requirement => !UNBUILT_JOB_REQUIREMENTS.includes(requirement);

// A job's stored `verificationRequirementsJob` without the requirements that cannot be asked for.
// It is stored either as a list or as a single value; a list stays a list, and a single value is
// returned as it is unless it is one of those, which reads as an empty list.
function offeredJobRequirements(stored) {
  if (Array.isArray(stored)) return stored.filter(isOfferedJobRequirement);
  return isOfferedJobRequirement(stored) ? stored : [];
}

// Search verification keys (`identity`, `work`, `education`, ...) without the unbuilt ones.
function offeredVerificationKeys(keys) {
  return keys.filter(key => !isUnbuilt(SEARCH_KEY_CATEGORIES[String(key).toLowerCase()]));
}

module.exports = {
  UNBUILT_JOB_REQUIREMENTS,
  offeredJobRequirements,
  offeredVerificationKeys,
};
